module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "mx-3",
    attrs: {
      "full-width": ""
    }
  }, [_c('v-card-title', {
    staticClass: "title"
  }, [_vm._v("\n        Merge clients\n        "), _c('v-spacer'), _vm._v(" "), _c('v-icon', [_vm._v("merge_type")])], 1), _vm._v(" "), _c('v-alert', {
    attrs: {
      "value": true,
      "type": "info",
      "dismissible": ""
    }
  }, [_c('h3', {
    staticClass: "subheading"
  }, [_vm._v("Before you start:")]), _vm._v(" "), _c('li', [_vm._v("Merging should be performed by a "), _c('strong', [_vm._v("practice owner")])]), _vm._v(" "), _c('li', [_vm._v("If you are marging clients owned by a different practitioner, make sure they have "), _c('strong', [_vm._v("shared them with a space that you own")])]), _vm._v(" "), _c('h3', {
    staticClass: "subheading mt-2"
  }, [_vm._v("How it works:")]), _vm._v(" "), _c('li', [_vm._v("Select two clients. One that you would like to keep, and one that you would like to remove.")]), _vm._v(" "), _c('li', [_vm._v("We'll load all the information for each client")]), _vm._v(" "), _c('li', [_vm._v("Read through the information and transfer relevant information from the client you woud like to delete to the client that you are keeping")]), _vm._v(" "), _c('li', [_vm._v("Once you've moved all the information, you can safely delete the empty client")])]), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('v-card', {
    staticClass: "ma-4"
  }, [_c('v-card-title', {
    staticClass: "subtitle-1 overline"
  }, [_vm._v("\n              1./ The client that you would like to "), _c('strong', {
    staticClass: "ml-1"
  }, [_vm._v("keep")])]), _vm._v(" "), _c('relationship-picker', {
    staticClass: "mx-2",
    attrs: {
      "multiple": false
    },
    on: {
      "selected": _vm.setLeft
    }
  }), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.left && _vm.left.id) ? _c('client-list-item', {
    attrs: {
      "show-spaces": "",
      "with-details": "",
      "owner": _vm.left.practitioner_id,
      "spaces": _vm.left.spaces,
      "with-action": false,
      "relationship-id": _vm.left.id,
      "client": _vm.left
    },
    model: {
      value: (_vm.relationshipId),
      callback: function($$v) {
        _vm.relationshipId = $$v
      },
      expression: "relationshipId"
    }
  }, [_c('v-chip', {
    staticClass: "v-chip--x-small",
    attrs: {
      "slot": "after-title",
      "outline": "",
      "label": ""
    },
    slot: "after-title"
  }, [_vm._v("#" + _vm._s(_vm.left.id))])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-center pt-5",
    attrs: {
      "xs2": ""
    }
  }, [_c('center', [_c('v-btn', {
    attrs: {
      "flat": "",
      "disabled": !_vm.left || !_vm.right
    },
    on: {
      "click": function($event) {
        return _vm.swap(_vm.left, _vm.right)
      }
    }
  }, [_c('v-icon', [_vm._v("chevron_left")]), _vm._v("\n              swap\n              "), _c('v-icon', [_vm._v("chevron_right")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('v-card', {
    staticClass: "ma-4"
  }, [_c('v-card-title', {
    staticClass: "subtitle-1 overline"
  }, [_vm._v("\n              2./ The client that you would like to "), _c('strong', {
    staticClass: "ml-1"
  }, [_vm._v("remove")])]), _vm._v(" "), _c('relationship-picker', {
    staticClass: "mx-2",
    attrs: {
      "multiple": false
    },
    on: {
      "input": function($event) {
        _vm.requests.delete.status = 0
      },
      "selected": _vm.setRight
    }
  }), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.right && _vm.right.id) ? _c('client-list-item', {
    attrs: {
      "show-spaces": "",
      "with-details": "",
      "owner": _vm.right.practitioner_id,
      "spaces": _vm.right.spaces,
      "with-action": false,
      "relationship-id": _vm.right.id,
      "client": _vm.right
    }
  }, [_c('v-chip', {
    staticClass: "v-chip--x-small",
    attrs: {
      "slot": "after-title",
      "outline": "",
      "label": ""
    },
    slot: "after-title"
  }, [_vm._v("#" + _vm._s(_vm.right.id))])], 1) : _vm._e(), _vm._v(" "), (_vm.deleteRequestStatus === 204) ? _c('v-alert', {
    staticClass: "ma-0",
    attrs: {
      "tile": "",
      "dismissible": "",
      "value": true,
      "type": "success"
    }
  }, [_vm._v("\n              Client has successfully been removed\n            ")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [(_vm.left && _vm.right && (_vm.left.id === _vm.right.id)) ? _c('span', {
    staticClass: "ml-3 red--text"
  }, [_c('v-icon', {
    attrs: {
      "small": "",
      "color": "error"
    }
  }, [_vm._v("warning")]), _vm._v("\n          these are the same users\n        ")], 1) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "mr-3",
    attrs: {
      "loading": _vm.comparisonRequest.loading,
      "disabled": !_vm.canCompare,
      "color": "primary"
    },
    on: {
      "click": _vm.compare
    }
  }, [_vm._v("Compare")])], 1), _vm._v(" "), _c('request-status', {
    attrs: {
      "request": _vm.comparisonRequest,
      "message403": "You do not have the required permissions for one of these users. Please ensure that you are the owner of both clients, or that the client is shared in a space which you own"
    }
  })], 1)], 1), _vm._v(" "), (_vm.right && _vm.leftDetail && _vm.rightDetail && !_vm.isDirty) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "mt-3 pb-5 mx-3"
  }, [_c('v-card-title', {
    staticClass: "subtitle-1 overline"
  }, [_vm._v("\n        Merge options:\n      ")]), _vm._v(" "), _c('v-card-text', {
    attrs: {
      "color": "gray lighten-4"
    }
  }, [_c('v-divider'), _vm._v(" "), (_vm.leftRecord && _vm.rightRecord) ? [_c('object-selector', {
    staticClass: "mt-3",
    attrs: {
      "with-edit": "",
      "title": "Choose details",
      "same-title": "Details are the same",
      "left": _vm.leftRecord,
      "right": _vm.rightRecord,
      "display-component": _vm.recordComponent,
      "display-component-left-attrs": {
        value: _vm.leftRecord
      },
      "display-component-right-attrs": {
        value: _vm.rightRecord
      }
    },
    on: {
      "edit": function($event) {
        return _vm.launchCustomerDetailsDialog(_vm.left.id)
      }
    },
    model: {
      value: (_vm.merge.record),
      callback: function($$v) {
        _vm.$set(_vm.merge, "record", $$v)
      },
      expression: "merge.record"
    }
  }, [_c('v-alert', {
    attrs: {
      "slot": "alert",
      "value": true,
      "type": "info"
    },
    slot: "alert"
  }, [_vm._v("\n              We will keep the record on the left. You can edit it if values on the right are more recent\n            ")])], 1)] : _vm._e()], 2)], 1), _vm._v(" "), (_vm.rightDetail && _vm.rightDetail.appointments && _vm.leftDetail && _vm.leftDetail.appointments) ? [_c('array-merge-preview', {
    staticClass: "ma-3",
    attrs: {
      "title": "Appointments",
      "loading": _vm.requests.transfer.appts.loading || _vm.comparisonRequest.loading,
      "left": _vm.leftDetail.appointments,
      "right": _vm.rightDetail.appointments,
      "item-title": "title",
      "item-sub-title": "start_time"
    },
    on: {
      "transfer": _vm.transferAppts
    }
  })] : _vm._e(), _vm._v(" "), (_vm.rightDetail && _vm.rightDetail.notes && _vm.leftDetail && _vm.leftDetail.notes) ? [_c('array-merge-preview', {
    staticClass: "ma-3",
    attrs: {
      "title": "notes",
      "loading": _vm.requests.transfer.notes.loading || _vm.comparisonRequest.loading,
      "left": _vm.leftDetail.notes,
      "right": _vm.rightDetail.notes,
      "item-title": "title",
      "item-sub-title": "start_time"
    },
    on: {
      "transfer": _vm.transferNotes
    }
  }, [_c('v-alert', {
    staticClass: "ma-0",
    attrs: {
      "type": "info",
      "value": true,
      "tile": ""
    }
  }, [_vm._v("\n          We can only show you notes to which you have access.\n          Please ensure that any team members\n          who may have have created notes\n          has shared them with an appropriate space\n        ")])], 1)] : _vm._e(), _vm._v(" "), (_vm.rightDetail && _vm.rightDetail.invoices && _vm.rightDetail.invoices.results && _vm.leftDetail && _vm.leftDetail.invoices && _vm.leftDetail.invoices.results) ? [_c('array-merge-preview', {
    staticClass: "ma-3",
    attrs: {
      "title": "invoices",
      "loading": _vm.requests.transfer.invs.loading || _vm.comparisonRequest.loading,
      "left": _vm.leftDetail.invoices.results,
      "right": _vm.rightDetail.invoices.results,
      "item-title": "title",
      "item-sub-title": "start_time"
    },
    on: {
      "transfer": _vm.transferInvoices
    }
  })] : _vm._e(), _vm._v(" "), _c('v-card', {
    staticClass: "mt-3"
  }, [_c('request-status', {
    attrs: {
      "request": _vm.requests.delete
    }
  }), _vm._v(" "), (_vm.right && _vm.right.id) ? _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "loading": _vm.requests.delete.loading,
      "color": "warning"
    },
    on: {
      "click": function($event) {
        return _vm.archive(_vm.right.id)
      }
    }
  }, [_vm._v("Archive right hand user")])], 1) : _vm._e()], 1)], 2) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e3454754","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/client/merge/index.vue
// module id = 1674
// module chunks = 2